<template>
    <svg width="82px" height="24px" viewBox="0 0 231.8 67.7" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>SUMIT</title>
        <path class="svg-red" fill="#E01B14"
            d="M229.3,12.5V4h-43.2v8.4h15.4v52.6h12.4V12.5H229.3z M183.7,4h-12.4v61.1h12.4V4z M162.7,65.1V4h-20.2 l-11.4,48.9L119.5,4H99.3v61.1h11V11.6l13.8,53.6H137l13.8-53.6v53.6L162.7,65.1L162.7,65.1z M91.3,45.2V4h-12v39.6 c0,6.6-0.4,14.4-9.8,14.4s-9.6-8.3-9.6-14.8V4H47.7v40.3c0,13.8,4.7,22,21.6,22S91.3,59.1,91.3,45.2 M43.6,49.4 c0-10-5.5-13.5-14.1-18.3L25,28.6c-5.1-2.8-9.5-5.4-9.5-10.3c0-4.3,2.8-7.2,7.7-7.2c6.2,0,7.3,3.7,7.3,8.2v1.5h12.3v-2.4 c0-11.6-6.8-15.6-19-15.6S3,7.3,3,19.2c0,9.5,5.7,13.3,13.1,17.6l5.1,2.9c5.7,3.2,9.9,5.4,9.9,10.6c0,4.9-3,7.7-8.3,7.7 c-7.4,0-8.1-5.2-8.1-10.6v-0.8H2.1v0.7c0,13.7,5.4,18.9,20.6,18.9C35,66.3,43.6,62,43.6,49.4"></path>
    </svg>
</template>
<script>
export default {
    name: "sumit"
}
</script>
<style lang="scss">
.svg-red {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.3) !important;
}
svg {
    &:hover {
        .svg-red {
            fill: #E01B14 !important;
            transition: .4s ease;

        }
    }
}
</style>
